<template>
  <div>
    <v-card>
      <v-app-bar color="primary accent-4" dense dark elevation="0">
        <v-toolbar-title>APPOINTMENTS</v-toolbar-title>
      </v-app-bar>

      <v-expansion-panels multiple>
        <v-expansion-panel v-for="(item, i) in appointments" :key="i">
          <v-expansion-panel-header>
            <div>
              <v-tooltip top v-if="item.agendaSlot && item.agendaSlot.state && item.agendaSlot.state == 'RESERVED_DASHBOARD'">
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar color="secondary" size="40" class="text-center me-2">
                    <v-icon v-bind="attrs" v-on="on" color="white"> mdi-laptop</v-icon>
                  </v-avatar>
                </template>
                <span>Manual Entry</span>
              </v-tooltip>
              <v-tooltip top v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar color="primary" size="40" class="text-center me-2">
                    <v-icon v-bind="attrs" color="white" v-on="on">mdi-tablet-android</v-icon>
                  </v-avatar>
                </template>
                <span>App Entry</span>
              </v-tooltip>
              {{ item.firstNamePatient }} {{ item.lastNamePatient }}
            </div>
            <v-spacer></v-spacer>
            <div class="text-right me-4" v-if="item.agendaSlot">{{ formatDateTime(item.agendaSlot.date) }}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="d-flex">
              <v-spacer></v-spacer>
              <v-btn small elevation="0" color="primary" class="mb-4 font-weight-bold" @click="openRescheduleDialog(item)"
                ><v-icon left>mdi-pencil</v-icon> Edit appointment time</v-btn
              >
            </div>
            <v-simple-table class="grey lighten-4" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="py-1">Address</td>
                    <td>{{ item.addressPatient }}</td>
                  </tr>
                  <tr>
                    <td class="py-1">Phone</td>
                    <td>{{ item.phonePatient }}</td>
                  </tr>
                  <tr>
                    <td class="py-1">Email</td>
                    <td>{{ item.emailPatient }}</td>
                  </tr>
                  <tr>
                    <td class="py-1">Application Through</td>
                    <td>{{ item.applicationThrough }}</td>
                  </tr>
                  <tr>
                    <td class="py-1">Self Pay</td>
                    <td>{{ item.selfPay ? 'Yes' : 'No' }}</td>
                  </tr>
                  <tr>
                    <td class="py-1">Policy/AZV Number</td>
                    <td>{{ item.policyNumber }}</td>
                  </tr>
                  <tr>
                    <td class="py-1">Doctor</td>
                    <td>{{ getDoctor(item.doctorId) }}</td>
                  </tr>
                  <tr v-if="item.comment">
                    <td class="py-1" colspan="2">
                      Comment: <br />
                      {{ item.comment }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <template v-if="loadingAppointments">
        <v-skeleton-loader
          v-for="(page, i) in 10"
          :key="'skeletonloader-' + i"
          type="list-item"
          ref="skeleton"
          class="mx-auto my-0"
        ></v-skeleton-loader>
      </template>

      <div class="pa-8 text-center title" v-if="!loadingAppointments && appointments.length == 0">No appointments on this date.</div>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {},
  data() {
    return {
      headers: [
        { text: 'Date and Time', value: 'date_time', sortable: false },
        { text: 'Policy Number', value: 'policy_number', sortable: false },
        { text: 'Self Pay', value: 'self_Pay', sortable: false },
        { text: 'First Name', value: 'first_name', sortable: false },
        { text: 'Last Name', value: 'last_name', sortable: false },
        { text: 'Date of Birth', value: 'dob', sortable: false },
        { text: 'Doctor Name', value: 'doctor', sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters('doctorOptionsStore', ['getDoctorOptions']),
    selectedDate() {
      return this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.selectedDate;
    },
    appointments() {
      return this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.appointments;
    },
    loadingAppointments() {
      return this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.loadingAppointments;
    },
    doctorOptions() {
      return this.getDoctorOptions; //.$store.state.config.doctorOptions;
    },
    locationSelected() {
      return this.$store.state.appointmentsCalendarStore.locationSelected;
    }
  },
  watch: {
    locationSelected(n, o) {
      if (n && n != o) this.getEntries();
    }
  },
  created() {
    this.$store.commit('appointmentsCalendarStore/SET_SELECTED_DATE', this.$route.params.selectedDate);
    this.getEntries();
  },
  methods: {
    formatDateTime(d) {
      return moment.utc(d, 'YYYY-MM-DDTHH:mm').local().format('DD-MMM-YYYY | h:mm A');
    },
    getEntries() {
      if (this.selectedDate) {
        this.$store.dispatch('appointmentsCalendarStore/getCalenderDayManualAppointments', {
          minDate: this.selectedDate,
          maxDate: this.selectedDate,
          locationId: this.locationSelected?.id ? this.locationSelected.id : 1
        });
      }
    },
    getDoctor(id) {
      if (!id) return 'No Doctor';

      this.$store.dispatch('doctorOptionsStore/fetchDoctorOptions').then((doctors) => {
        return doctors.filter((doctor) => +doctor.id == +id)[0].text; //doctor.value changed to doctor.id.
      });

      if (this.doctorOptions.length == 0) {
        this.$store.dispatch('doctorOptionsStore/fetchDoctorOptions').then((doctors) => {
          return doctors.filter((doctor) => +doctor.value == +id)[0].text;
        });
      } else {
        return this.doctorOptions.filter((doctor) => doctor.value == id)[0].text;
      }
    },
    ...mapActions('doctorOptionsStore', ['fetchDoctorOptions']),
    openRescheduleDialog(appointment) {
      this.$store.commit('appointmentsCalendarStore/SET_CURRENT_SELECTED_SLOT_ID', appointment.agendaSlot.id);
      this.$store.commit('appointmentsCalendarStore/SET_RESCHEDULE_APPOINTMENT_DIALOG', true);
    }
  }
};
</script>

<style lang="scss">
</style>
